import type { SectionClassPreset } from '@jht/brand-page-builder/core';

const breakpoints = ['', 'sm-', 'md-', 'lg-', 'xl-', 'xxl-'];
const sizes = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'auto'];

const spacingUtilities = ['m', 'p'].flatMap((property) =>
    ['', 't', 'b', 's', 'e', 'x', 'y'].flatMap((side) =>
        breakpoints.flatMap((breakpoint) =>
            sizes.map((size) => `${property}${side}-${breakpoint}${size}`),
        ),
    ),
);

const LAYOUT_AND_COLOR_CLASSES = [
    'container',
    'container-fluid',
    'text-center',
    'text-white',
    'text-dark',
    'bg-white',
    'bg-black',
    'bg-primary',
    'bg-secondary',
    'bg-tertiary',
    'bg-gray-30',
    'bg-gray-20',
    'bg-gray-10',
    'text-bg-dark',
    'text-bg-secondary',
    'text-bg-tertiary',
    'position-relative',
    'overflow-hidden',
];

export const SECTION_CLASS_OPTIONS: string[] = [
    ...spacingUtilities,
    ...LAYOUT_AND_COLOR_CLASSES,
];

export const SECTION_CLASS_PRESETS: SectionClassPreset[] = [
    { label: 'Flush, no spacing', value: '' },
    { label: 'Container, margin below', value: 'container mb-4' },
    { label: 'Container, padded', value: 'container py-4 py-lg-5' },
    { label: 'Container, padded large', value: 'container py-5 py-lg-7' },
    { label: 'Full-width, padded', value: 'py-4 py-lg-5' },
    { label: 'Dark band, padded', value: 'text-bg-dark py-4 py-lg-5' },
    { label: 'Light grey band', value: 'bg-gray-20 py-4 py-lg-5' },
    { label: 'Tertiary band', value: 'text-bg-tertiary py-4 py-lg-5' },
];

// The style-guide color classes the page builder offers on `color` fields, in dropdown
// order. Values paint the swatch beside each class.
export const COLOR_CLASSES: Record<string, string> = {
    'bg-transparent': 'transparent',
    'bg-gray-20': '#f1f1f1',
    'bg-gray-30': '#ececec',
    'text-bg-light': '#ffffff',
    'text-bg-white': '#ffffff',
    'text-bg-gray-10': '#f7f7f7',
    'text-bg-gray-20': '#f1f1f1',
    'text-bg-gray-30': '#ececec',
    'text-bg-tertiary': '#dae7ee',
    'text-bg-secondary': '#3c5b77',
};
